import { MedicalAppointmentValidation } from "../medical-appointment-validation";
import { ReferringPhysicianFilter } from "../referring-physician";
import { ReferringPhysicianInstituteFilter } from "../referring-physician-institute-filter";

export class IntegratedAdmissionAppointmentValidation {
  CredentialNumber: string;
  Code: string;
  PreAuth: string;
  ReferringPhysician: ReferringPhysicianFilter;
  ReferringPhysicianInstitute: ReferringPhysicianInstituteFilter;
  PrescriptionDate?: Date;
  Mask: string;
  RequiredCIEDiagnosis: boolean;
  DiagnosisCodeMode: string;
  RequiredValidation: boolean;
  RequiredCode: boolean;
  RequiredPreAuth: boolean;
  RequiredCredentialNumber: boolean;
  AuthorizationNumber: string;
  MedicalAppointmentValidation: MedicalAppointmentValidation;
  AgreementPriceIdNoValidated: number[];
  ManualAgreementPriceIdNoValidated: number[];
  InvalidOnError: boolean;
  InvalidOnRegister: boolean;
  InvalidOnVerification: boolean;
  IsRegister: boolean;
  IsVerification: boolean;
  HasError: boolean;
}
